import axiosInstance from '../../config';

export const createPaymentLinkService = async (token, data) => {
  try {
    const response = await axiosInstance.post(
      'rz/creating_payment_link',
      data, // request body
      {
        headers: {
          Authorization: `Bearer ${token}`, // 👈 send token in headers
          "Content-Type": "application/json",
        },
      }
    );

   

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Link failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,
    };
  }
};
